module.exports = __webpack_public_path__ + "static/home/img/dc.81b318d0.png";